module.exports = __webpack_public_path__ + "img/15f.a124e429.png";